var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoxIcon = function SvgBoxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#box-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0050B3",
    d: "M15 4.326V4.32l4.491 2.011L24 4.641 12 .14 0 4.64l12 4.5 4.491-1.685L12 5.606V5.6zM0 6.14v13.5l11.25 4.22v-13.5zm6 13.55-3-1.125v-1.6l3 1.125zM19.5 7.828v3.758l-3 1.125V8.953l-3.75 1.407v13.5L24 19.64V6.14z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "box-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgBoxIcon;